import { cn } from 'cn';

import { KpiUsersActive } from './KpiUsersActive';
import { KpiUsersRegistered } from './KpiUsersRegistered';

/**
 * UserKpis
 *
 * Displays all user-related KPIs (registered users, active users).
 */
export const UserKpis = ({ className, style }: ComponentStyling) => {
  return (
    <div
      className={cn(
        'grid grid-cols-[repeat(auto-fit,minmax(0,1fr))] gap-4',
        className,
      )}
      style={style}
    >
      <KpiUsersRegistered />
      <KpiUsersActive />
    </div>
  );
};
